import { Component } from '@angular/core';
import { PlansComponent } from '../plans/plans.component';
import { RouterModule } from '@angular/router';
import { BuyBookComponent } from "../../../../buy-book/buy-book.component";

@Component({
  selector: 'app-product',
  standalone: true,
  imports: [PlansComponent, RouterModule, BuyBookComponent],
  templateUrl: './product.component.html',
  styleUrl: './product.component.css'
})
export class ProductComponent {

}
